/* eslint-disable camelcase */
export interface ProfileInformation {
  name: {
    value: string;
    match: string;
  };
  lastname: {
    value: string;
    match: string;
  };
  identification: {
    value: string;
    match: string;
  };
  country: {
    value: string;
    match: string;
  };
}

export interface ReportInformation {
  check_id: string;
  created_date: string;
  create_hour: string;
  status: string;
}

export interface Cell {
  label: string;
  value: string;
}

export interface Row {
  cells: Cell[];
}

export interface Table {
  title?: string;
  rows: Row[];
}

export interface Detail {
  id: number;
  database_name: string;
  found_first_name?: string;
  found_last_name?: string;
  result?: string;
  route?: string;
  severity?: string;
  tables: Table[];
}

export interface Explanation {
  icon: string;
  text: string;
}

export interface Dataset {
  id: number;
  status: string;
  name: string;
  sources: string;
  progress: number;
  score?: number;
  details: Detail[];
  explanations?: Explanation[];
}

export interface Result {
  homonymy: number;
  score: number;
  confidence_level: string;
  profile_information: ProfileInformation;
  report_information: ReportInformation;
  datasets: Dataset[];
}

export interface HeaderInfo {
  country: string
  documentType: string
  documentNumber: string
}

export type CheckType = 'person' | 'vehicle' | 'company'

export type ResultTabType = 'score' | 'detail'

export interface ResultState {
  result: Result;
  headerInfo: HeaderInfo | null;
  checksCounter: number;
  checkType: CheckType;
  resultTabType: ResultTabType;
  checksCounterUpdated: boolean;
}

export const defaultState: ResultState = {
  result: {
    homonymy: 0,
    score: 0,
    confidence_level: '',
    profile_information: {
      name: {
        value: '',
        match: ''
      },
      lastname: {
        value: '',
        match: ''
      },
      identification: {
        value: '',
        match: ''
      },
      country: {
        value: '',
        match: ''
      }
    },
    report_information: {
      check_id: '',
      created_date: '',
      create_hour: '',
      status: ''
    },
    datasets: [
      {
        id: 0,
        status: '',
        name: '',
        sources: '',
        progress: 0,
        details: [
          {
            id: 0,
            database_name: '',
            tables: [
              {
                rows: [
                  {
                    cells: [
                      {
                        label: '',
                        value: ''
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  headerInfo: null,
  checksCounter: 0,
  checkType: 'person',
  resultTabType: 'score',
  checksCounterUpdated: false
}

export default {
  ...defaultState
}
